<template>
  <div class="karta-visualization" :class="classStyle">
    <div class="karta__header">
      <p>Ustecka Karta Mieszkańca</p>

      <qrcode-vue
        v-if="card && card.number"
        level="H"
        style="text-align: center;"
        class="qr-code"
        :value="card.number"
        :size="100"
      />
    </div>

    <div class="karta__footer">
      <div v-if="card" class="karta__id">
        <p class="sr-only">Numer karty:</p>

        {{ card.number }}
      </div>

      <div class="karta__username">
        <p class="sr-only">Właściciel karty:</p>

        {{ profile.firstName }}

        {{ profile.lastName }}
      </div>
    </div>
  </div>
</template>

<script>
import { CardState } from '@witkac/kartamiejska-shared';
import QrcodeVue from 'qrcode.vue';
import { mapState } from 'vuex';

import { cardMixin } from '@/mixins/cardMixin';

// @vuese
// Widok karty
// @group Home
export default {
  components: { QrcodeVue },
  mixins: [cardMixin],
  computed: {
    ...mapState({
      profile: state => state.profile.data,
      cardStateColor: state => state.settings.CARD_STATE_COLOR.value
    }),
    classStyle() {
      if (!this.card) {
        return CardState[CardState.INACTIVE];
      }
      if (this.isExpired || this.isBlocked) {
        return 'BLOCKED';
      }

      for (const stateColor in this.cardStateColor) {
        if (this.cardStateColor[stateColor].includes(this.card.state)) {
          return stateColor;
        }
      }
      return CardState[CardState.ACTIVE];
    }
  }
};
</script>
